"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractSearchCommand = void 0;
class AbstractSearchCommand {
    constructor() {
        this.addActivityData = (app, response) => {
            var _a, _b;
            app.metadata = {
                activity: +response.headers[`activity_app_${app.pushApplicationID.toLowerCase()}`],
                deviceCount: +response.headers[`devicecount_app_${(_a = app.pushApplicationID) === null || _a === void 0 ? void 0 : _a.toLowerCase()}`],
            };
            // Add info to the variant
            app.variants = (_b = app.variants) === null || _b === void 0 ? void 0 : _b.map(variant => {
                var _a, _b;
                variant.metadata = {
                    activity: +response.headers[`activity_variant_${(_a = variant.variantID) === null || _a === void 0 ? void 0 : _a.toLowerCase()}`],
                    deviceCount: +response.headers[`devicecount_variant_${(_b = variant.variantID) === null || _b === void 0 ? void 0 : _b.toLowerCase()}`],
                };
                return variant;
            });
            return app;
        };
        this.getPage = (appList, page, pageSize) => {
            const firstIndex = pageSize * page;
            const endIndex = firstIndex + pageSize;
            return appList.slice(firstIndex, endIndex);
        };
        this.ensureIsArray = (obj) => (obj instanceof Array ? obj : [obj]);
        this.applyPushApplicationFilter = (apps, filter) => {
            if (filter) {
                return apps.filter(app => (!filter.name || filter.name === app.name) &&
                    (!filter.description || filter.description === app.description) &&
                    (!filter.pushApplicationID || filter.pushApplicationID === app.pushApplicationID) &&
                    (!filter.developer || filter.developer === app.developer));
            }
            return apps;
        };
        this.getAllApplications = async (api, filter, currentResult = [], startWithPage = 0) => {
            const url = '/applications';
            const response = await api.get(url, {
                params: {
                    includeDeviceCount: (filter === null || filter === void 0 ? void 0 : filter.includeDeviceCount) === true,
                    includeActivity: (filter === null || filter === void 0 ? void 0 : filter.includeActivity) === true,
                    page: startWithPage,
                    per_page: 100,
                },
            });
            const appList = this.ensureIsArray(response.data);
            if (appList.length > 0) {
                return await this.getAllApplications(api, filter, this.applyPushApplicationFilter([...currentResult, ...appList]), startWithPage + 1);
            }
            return currentResult;
        };
    }
}
exports.AbstractSearchCommand = AbstractSearchCommand;
//# sourceMappingURL=AbstractSearchCommand.js.map